const NODE_ENV = {
    // ZCT_API: "http://172.16.0.34:8000", //启骏
    // ZCT_API: "http://172.16.0.230:8111", //黄野
    // ZCT_API: "http://172.16.0.13:8000", //桂进
    // ZCT_API: "http://121.37.233.232:8008/api", // 资产通生产环境
    // ZCT_API: "http://172.16.0.57:8000", //周鹏
    // ZCT_API: "http://172.16.0.45:8000", // 耀桦
    // ZCT_API: "http://172.16.1.12:8112", // 壮鑫
    // ZCT_API: "http://172.16.0.82:8112", // 小芳
    // ZCT_API: "http://kf.vpclub.cn/zct/api", // 预演环境
    // ZCT_API: "http://124.71.45.240/zct/api", //
    // ZCT_API: 'http://zct.gov.vpclub.cn/zct/api', //测试环境
    // ZCT_API: 'http://inside-zct-pc.web.172.16.125.12.xip.io/zct/api',
    // ZCT_API: "http://172.16.0.58:8000", // 资产通测试服务器地址
    //  ZCT_API: "/zct/api",
    ZCT_API: process.env.VUE_APP_ZCT_API,
    // ZCT_API: "/api",

    // ZCT_API: "http://localhost:8000",
    JST_API: " http://121.37.233.232:8008/jstapi/jst", // 捷算通测试服务器地址
    ZCT_BS_API: "http://139.159.144.119/erp", // 资产通后台测试服务器地址
    // GJSC: process.env.GJSC,
    GJSC: "http://121.37.233.232:8008/gjsc",
    ZCT_SECRET: "21fa6sd1f95w1133edsafas6"
};
export default NODE_ENV;
